import { render, staticRenderFns } from "./StudentSuspendHorizontalBarChart.vue?vue&type=template&id=582a8fa6&"
import script from "./StudentSuspendHorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./StudentSuspendHorizontalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports